export default "__VITE_ASSET__ChjgOWhT__"